module.exports = __webpack_public_path__ + "media/images/common/side_cart_bg-3edc13b5fec7e0231a5e4dfa4ce8da52.gif";